module.exports = __webpack_public_path__ + "img/infinicept.914cda6a.png";